import { useEffect, useState } from 'react'

// locals
import PoolVehicleService from 'service/PoolVehicleService'
import { IPoolVehicleTimeTableList } from 'types/PoolVehicleType'
import DateUtil from 'utils/DateUtil'
import { groupBy } from 'utils/Miscellaneous'

export default function useGetPoolVehicleResTable(
  locationId: number,
  poolVehicleId: number,
  dateFromList: Date,
  isCalendar: boolean = false
) {
  const [timeTable, setTimeTable] = useState<IPoolVehicleTimeTableList[] | []>([])
  const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
  const [tableWeek, setTableWeek] = useState(selectedDate)
  const [availableDates, setAvailableDates] = useState({ start: 0, end: 0 })
  const [selectedReservations, setSelectedReservations] = useState<IPoolVehicleTimeTableList[]>()
  const [sidebarVisible, setSidebarVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    PoolVehicleService.getPoolVehicleDetailByLocationId(locationId)
      .then((res) =>
        setAvailableDates({
          start: res.data.reservationStartDay,
          end: res.data.reservationEndDay,
        })
      )
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }, [locationId])

  useEffect(() => {
    setLoading(true)
    PoolVehicleService.getPoolVehicleTimeTableList({
      poolVehicleId: poolVehicleId,
      startDate: DateUtil.formatDateToString(tableWeek.start),
      endDate: DateUtil.formatDateToString(tableWeek.end),
    })
      .then((res) => setTimeTable(res.data))
      .finally(() => setLoading(false))

    /* Reset selected appointment time */
    if (!isCalendar) setSelectedReservations(undefined)
  }, [poolVehicleId, tableWeek.start, tableWeek.end, isCalendar])

  useEffect(() => {
    const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
    setTableWeek(selectedDate)
  }, [dateFromList, poolVehicleId])

  const dailyAppointments: [] | Record<string, IPoolVehicleTimeTableList[]> = !!timeTable.length
    ? groupBy(timeTable, (v) => DateUtil.formatStringToDate(v.reservationStartHour))
    : []

  return {
    availableDates,
    tableWeek,
    setTableWeek,
    selectedReservations,
    setSelectedReservations,
    sidebarVisible,
    setSidebarVisible,
    dailyAppointments,
    loading,
  }
}
